import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2.188 5.625a.937.937 0 1 1 1.874 0 .937.937 0 0 1-1.875 0M6.25 5.625c0-.345.28-.625.625-.625h10a.625.625 0 1 1 0 1.25h-10a.625.625 0 0 1-.625-.625M2.188 10a.937.937 0 1 1 1.874 0 .937.937 0 0 1-1.875 0M6.25 10c0-.345.28-.625.625-.625h10a.625.625 0 1 1 0 1.25h-10A.625.625 0 0 1 6.25 10M2.188 14.375a.937.937 0 1 1 1.874 0 .937.937 0 0 1-1.875 0M6.25 14.375c0-.345.28-.625.625-.625h10a.625.625 0 1 1 0 1.25h-10a.625.625 0 0 1-.625-.625"
    }, null, -1)
  ])))
}
export default { render: render }